import React from "react";
import SignatureCanvas from "react-signature-canvas";

const FullScreenSignatureModal = ({
  showFullScreenSign,
  activeGuestIndex,
  fullScreenSigCanvas,
  signErr,
  handleFullScreenSave,
  setsignErr
}) => {
  if (!showFullScreenSign) return null;
  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50" id='signature-wrapper'>
      <div className="w-full h-full flex flex-col relative">
        <div className="absolute top-4 left-0 right-0 text-center z-50">
          <h2 className="text-white text-xl font-bold bg-black bg-opacity-70 inline-block px-4 py-2 rounded-lg">
            {activeGuestIndex === null ? (
              "Main Guest Signature"
            ) : (
              `Guest ${activeGuestIndex + 1} Signature`
            )}
          </h2>
        </div>
        
        <div className="flex-1 bg-white">
          <SignatureCanvas
          canvasProps={{
            className: "w-full h-full",
          }}
            // canvasProps={{ width: window.innerWidth, height: window.innerHeight }}
            ref={fullScreenSigCanvas}
            penColor="black"
            minWidth={1}
            velocityFilterWeight={0.3}
            onBegin={() => setsignErr("")}
          />
        </div>

        <div className="absolute top-4 left-4 flex gap-4 z-50">
          <button
            onClick={handleFullScreenSave}
            className="bg-green-600 text-white px-4 py-2 rounded shadow-md hover:bg-green-700 transition"
          >
            Confirm
          </button>
          <button
            onClick={() => fullScreenSigCanvas.current?.clear()}
            className="bg-white text-green-500 border border-green-500 px-4 py-2 rounded hover:bg-green-100 transition"
          >
            Clear
          </button>
        </div>
        
        {signErr && (
          <div className="absolute top-4 right-5 bg-white text-red-600 px-4 py-2 rounded shadow z-50 text-sm font-medium">
            {signErr}
          </div>
        )}
      </div>
    </div>
  );
};

export default FullScreenSignatureModal;